<template>
  <nav class="ignite-nav" :class="{ 'solid-nav': $route.path === '/ignite-faq' }" aria-label="Ignite navigation" @keydown.esc="isMenuOpen = false">
    <div class="nav-inner">
      <router-link to="/ignite" aria-label="Hanga Venture Ignite home" @click="isMenuOpen = false">
        <img src="../assets/logo.svg" class="nav-logo" alt="Hanga">
      </router-link>
      <div class="desktop-links">
        <router-link to="/">Hanga Pitch</router-link>
        <router-link to="/ignite-faq">FAQs</router-link>
        <a class="nav-apply" :href="applicationUrl" target="_blank" rel="noopener noreferrer">Apply now <span aria-hidden="true">↗</span></a>
      </div>
      <button type="button" class="menu-toggle" :aria-expanded="isMenuOpen" aria-controls="ignite-mobile-menu" :aria-label="isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'" @click="isMenuOpen = !isMenuOpen">
        <svg v-if="!isMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
        <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6" /></svg>
      </button>
    </div>
    <div v-if="isMenuOpen" id="ignite-mobile-menu" class="mobile-links">
      <router-link to="/" @click="isMenuOpen = false">Hanga Pitch</router-link>
      <router-link to="/ignite-faq" @click="isMenuOpen = false">FAQs</router-link>
      <a class="nav-apply" :href="applicationUrl" target="_blank" rel="noopener noreferrer" @click="isMenuOpen = false">Apply now <span aria-hidden="true">↗</span></a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavIgnite',
  data() {
    return {
      isMenuOpen: false,
      applicationUrl: 'https://hanga.acceleratorapp.co/apply/program/hanga-venture-ignite',
    };
  },
  watch: {
    $route() { this.isMenuOpen = false; },
  },
};
</script>

<style scoped>
.ignite-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 60; background: #243163; color: white; font-family: Gramatika, sans-serif; border-bottom: 1px solid #ffffff26; }
.solid-nav { background: #243163; }
.nav-inner { width: min(1200px, calc(100% - 96px)); margin-inline: auto; min-height: 96px; display: flex; align-items: center; justify-content: space-between; gap: 24px; }
.nav-logo { width: 132px; height: 44px; object-fit: contain; }
.desktop-links { display: flex; gap: 32px; align-items: center; font-size: 14px; font-weight: 700; }
.desktop-links > a:not(.nav-apply):hover, .mobile-links > a:not(.nav-apply):hover { color: #d4fff5; }
.nav-apply { display: inline-flex; justify-content: space-between; align-items: center; gap: 22px; background: #00a8a8; color: white; padding: 13px 20px; border-radius: 6px; min-height: 46px; font-weight: 700; }
.nav-apply:hover { background: #243163; }
.menu-toggle { display: none; height: 44px; width: 44px; align-items: center; justify-content: center; border: 1px solid #ffffff55; border-radius: 6px; }
.menu-toggle svg { width: 24px; height: 24px; }
.mobile-links { display: none; }
.ignite-nav :is(a, button):focus-visible { outline: 3px solid #f7810b; outline-offset: 4px; }
@media (max-width: 900px) { .nav-inner { width: calc(100% - 48px); } }
@media (max-width: 640px) { .ignite-nav, .mobile-links { background: #00a8a8; }
  .nav-inner { width: calc(100% - 40px); min-height: 76px; }
  .nav-logo { width: 112px; height: 36px; }
  .desktop-links { display: none; }
  .menu-toggle { display: flex; }
  .mobile-links { display: flex; flex-direction: column; position: absolute; left: 0; right: 0; top: 100%; background: #00a8a8; padding: 16px 20px 24px; box-shadow: 0 16px 28px #0003; }
  .mobile-links > a { padding: 14px 16px; font-size: 16px; min-height: 48px; }
  .mobile-links .nav-apply { margin-top: 10px; }
}
</style>
